<template>
  <StepComponent>
    <v-container>
      <div class="h6 py-2 font-weight-bold">General Sample Information</div>
      <v-row v-if="hasMultipleClients" dense>
        <v-col>
          <v-select
            label="Select a Client"
            v-model="client_id"
            disabled
            :items="clients"
            item-value="id"
            item-text="title_with_id"
            @change="saveToLocalStorage('client_id')"
          />
        </v-col>
      </v-row>
      <!-- <LabSelection v-model="lab_id" /> -->
      <GeneralSampleInformation
        :show-barcode-error="showBarcodeError"
        @number-of-samples-modal-opened="onNumberOfSamplesModalOpened"
      />
    </v-container>
    <v-container class="my-6">
      <!-- <div class="h6 py-2 font-weight-bold">Sampling Information</div>
      <SamplingInformation /> -->
      <!-- <SampleImages :sample-id="active_sample.id ? active_sample.id : null" /> -->
    </v-container>
  </StepComponent>
</template>

<script>
import StepComponent from "@/components/samples/SampleWizardSteps/StepComponent";
// import SamplingInformation from "@/components/samples/SampleWizardSteps/SampleStepComponents/SamplingInformation";
import GeneralSampleInformation from "@/components/newSamples/SampleWizardSteps/SampleStepComponents/GeneralSampleInformation";
import { mapActions, mapGetters, mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
// import LabSelection from "@/components/labs/LabSelection";
import isString from "lodash.isstring";
// import SampleImages from "../components/SampleImages.vue";

export default {
  name: "SampleInformationStep",
  components: {
    StepComponent,
    GeneralSampleInformation
    // SampleImages
    // SamplingInformation,
    // LabSelection
  },
  watch: {
    client_id(clientId) {
      const client = this.clients.find(item => item.id === clientId);
      if (client && client.lab_id !== this.lab_id) {
        this.lab_id = client.lab_id;
      } else {
        this.getSampleTestComponents();
      }
    },
    selectedClient(newVal) {
      if (newVal && newVal.id) {
        this.client_id = newVal.id;
      }
    }
  },
  computed: {
    ...mapFields("samples", [
      "active_sample.copy_to_ids",
      "active_sample.client_id",
      "active_sample.lab_id"
    ]),
    ...mapGetters("clients", ["selectedClient", "hasMultipleClients"]),
    ...mapState("clients", { clients: "items" }),
    ...mapState("samples", ["errors"]),
    ...mapState("samples", ["active_sample"]),
    ...mapFields("sampleWizard", [
      "wizard.isBulk",
      "wizard.sampleIds",
      "wizard.barcodes",
      "wizard.barcode_start",
      "wizard.barcode_end",
      "wizard.lab_id_start",
      "wizard.lab_id_end"
    ])
  },
  data() {
    return {
      showBarcodeError: false,
      error: {
        message: ""
      },
      isEdit: window.location.pathname.includes("sample-edit")
    };
  },
  methods: {
    ...mapActions("samples", [
      "addSample",
      "getSampleTestComponents",
      "addBulkSamples",
      "editBulkSamples"
    ]),
    ...mapActions(["notify"]),
    ...mapActions("samples", ["updateSampleSet", "setActive"]),
    onNumberOfSamplesModalOpened() {
      this.$emit("number-of-samples-modal-opened");
    },
    beforeContinue() {
      // Reset barcode error before attempting
      this.showBarcodeError = false;
      // Add sample to backend (or update if an ID exists on active_sample)
      return this.isBulk
        ? this.saveBulkSamples()
        : this.addSample().then(res => {
            if (
              !this.active_sample.id &&
              !res &&
              this.active_sample.sample_bag_barcode
            ) {
              this.error.message =
                this.errors &&
                this.errors?.sample_bag_barcode &&
                this.errors?.sample_bag_barcode?.unique
                  ? this.errors?.sample_bag_barcode?.unique
                  : !res.success
                  ? res?.message ||
                    res?.errors?.join(", ") ||
                    res?.error?.message
                  : "";
              this.notify({
                message: `An error occured while saving the sample data! ${this.error.message}`,
                color: "error"
              });
              return false;
            }
            return !!res;
          });
    },
    async saveBulkSamples() {
      try {
        if (this.sampleIds && this.sampleIds.length > 0) {
          return await this.saveBulkSamplesEdit();
        }

        const result = await this.addBulkSamples(this.active_sample);

        if (result?.success) {
          this.sampleIds = result.sampleIds;
          this.barcodes = result.barcodes;
          this.barcode_start = this.barcodes[0];
          this.barcode_end = this.barcodes[this.barcodes.length - 1];

          if (this.sampleIds?.length) {
            Promise.all([this.setActive(this.sampleIds[0])]).then(data => {
              if (data.includes(false)) {
                this.error.message =
                  "An error occurred while retrieving this sample";
              } else {
                this.lab_id_start = this.active_sample.slug;
              }
            });
          }

          return true;
        }

        const { status, errors, message, error, success } = result || {};

        let errorMsg = "";

        if (errors && !success) {
          const baseMessage = Object.values(errors)
            .filter(x => typeof x === "string")
            .join(", ");

          const existingCodes = errors.existing_barcodes
            ? `Existing barcode(s): ${errors.existing_barcodes.join(", ")}`
            : "";

          errorMsg = `${baseMessage}${
            existingCodes ? " — " + existingCodes : ""
          }`;
        } else if (status === 500) {
          errorMsg = "Internal server error occurred. Please try again later.";
        } else {
          errorMsg = message || error?.message || "Operation failed.";
        }

        this.error.message = errorMsg;

        this.notify({
          message: `Failed to add bulk samples! ${errorMsg}`,
          color: "error"
        });

        return false;
      } catch (err) {
        this.notify({
          message: `An unexpected error occurred.`,
          color: "error"
        });
        console.error(err);
        return false;
      }
    },
    async saveBulkSamplesEdit() {
      const result = await this.editBulkSamples({
        ids: this.sampleIds,
        farm_id: this.active_sample.farm_id,
        lab_id: this.active_sample.lab_id,
        feed_type_id: this.active_sample.feed_type_id,
        farms_source_id: this.active_sample.farms_source_id,
        description: this.active_sample.description,
        cutting: this.active_sample.cutting,
        crop_year: this.active_sample.crop_year,
        date_collected: this.active_sample.date_collected,
        is_preground: this.active_sample.is_preground,
        sample_condition: this.active_sample.sample_condition,
        copy_to: this.active_sample.copy_to,
        client_id: this.active_sample.client_id
      });

      if (result.success) {
        return true;
      } else {
        if (result?.errors && result?.errors.length) {
          this.notify({
            message: `Failed to edit bulk samples! ${result.errors.join(", ")}`,
            color: "error"
          });
        }
        if (result?.message) {
          this.notify({
            message: `Failed to edit bulk samples! ${result.message}`,
            color: "error"
          });
        }
      }
      return false;
    },
    saveToLocalStorage(key) {
      localStorage.setItem(key, JSON.stringify(this[key]));
    }
  },
  mounted() {
    this.loading = true;
    this.getSampleTestComponents()
      .then(() => {
        this.loading = false;
      })
      .catch(e => {
        // If an error is a string, set it as the error message for the wizard
        this.setError(isString(e) ? e : "An unknown error occurred.");
        // Log to console if this was a non-string error
        if (!isString(e)) console.error(e);
      });

    this.client_id = !this.isEdit
      ? this.selecteClient && this.selectedClient.id
        ? this.selectedClient.id
        : localStorage.getItem("client_id")
        ? JSON.parse(localStorage.getItem("client_id"))
        : this.client_id
        ? this.client_id
        : null
      : this.client_id;
  }
};
</script>

<style scoped></style>
